import { AcceptTermsOfServicePage } from "./pages/AcceptTermsOfServicePage";
import { AccessibilityPage } from "./pages/AccessibilityPage";
import { LegalNoticePage } from "./pages/LegalNoticePage";
import { SitemapPage } from "./pages/SitemapPage";
import { TermsOfServicePage } from "./pages/TermsOfServicePage";
import { ProtectionPolicyPage } from "./pages/ProtectionPolicyPage";

export const AppRoutes = () => (
  <>
    <AcceptTermsOfServicePage />
    <AccessibilityPage />
    <LegalNoticePage />
    <SitemapPage />
    <ProtectionPolicyPage />
    <TermsOfServicePage />
  </>
);
